module.exports = __webpack_public_path__ + "static/media/tvn.205ad64b.png";